// extracted by mini-css-extract-plugin
module.exports = {"heading":"product-accordion_heading__p0oyt","chevron":"product-accordion_chevron__1maFb"};